(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ed-motion-budget"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ed-motion-budget')){
  customElements.define('ed-motion-budget',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.scopes=new Map();
      this.preference=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.selector='.edr,.edps,.edw,.edx,.eda,.edd,.edh,.edk,.edrp,.edw-card,.eda-card,.edr-live';
      this.sync=()=>{
        this.scopes.forEach((visible,element)=>{
          if(!element.isConnected){this.observer?.unobserve(element);this.scopes.delete(element);return;}
          element.dataset.edMotion=visible&&!document.hidden&&!this.preference.matches?'running':'paused';
        });
      };
      this.observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
        entries.forEach(entry=>this.scopes.set(entry.target,entry.isIntersecting));this.sync();
      },{threshold:0.01}):null;
      this.scan=(root)=>{
        root.querySelectorAll(this.selector).forEach(element=>{
          if(this.scopes.has(element))return;
          this.scopes.set(element,!this.observer);element.dataset.edMotion='paused';
          this.observer?.observe(element);
        });this.sync();
      };
      this.onLoad=event=>this.scan(event.target);
      this.onUnload=event=>{
        this.scopes.forEach((visible,element)=>{if(event.target.contains(element)){this.observer?.unobserve(element);this.scopes.delete(element);}});
      };
      document.addEventListener('visibilitychange',this.sync);
      this.preference.addEventListener('change',this.sync);
      document.addEventListener('shopify:section:load',this.onLoad);
      document.addEventListener('shopify:section:unload',this.onUnload);
      this.scan(document);
    }
    disconnectedCallback(){
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange',this.sync);
      this.preference?.removeEventListener('change',this.sync);
      document.removeEventListener('shopify:section:load',this.onLoad);
      document.removeEventListener('shopify:section:unload',this.onUnload);
      this.ready=false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ed-product-hud"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ed-product-hud')) {
    const hudObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => { entry.target.dataset.active = String(entry.isIntersecting); });
    }, { threshold: 0.05 }) : null;
    customElements.define('ed-product-hud', class extends HTMLElement {
      connectedCallback() {
        if (hudObserver) hudObserver.observe(this);
        else this.dataset.active = 'true';
      }
      disconnectedCallback() { if (hudObserver) hudObserver.unobserve(this); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
